import React from 'react';
import HomePage from './components/HomePage';
import './styles/Global.css';

const App = () => {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
};

export default App;
